import React from 'react';
import { Button, Icon } from '@iq/react-components';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

import { getActiveSiteId } from '../../../../../bundles/sites';

const LayoutBanner = () => {
  const site = useSelector(getActiveSiteId);
  const navigate = useNavigate();
  const handleGoToLayout = () => {
    navigate(`/sites/${site}/admin/layout`);
  };
  return (
    <div className="layout-banner">
      <div className="layout-banner-message">
        <div className="message-content">
          <Icon
            className="icon-color"
            icon="he-preview-off"
            size="s"
            fill="black"
          />
          <p>
            This page is visible only to site managers. Editing and preview will not affect other
            users.
          </p>
        </div>
      </div>
      <Button
        className="layout-banner-button"
        onClick={handleGoToLayout}
        activity="secondary"
      >
        Go to Layout
      </Button>
    </div>
  );
};

export default LayoutBanner;
